<google-map height="100%" width="100%" [center]="center" [zoom]="zoom" #mapContainer id="map">
  <!-- Render dynamic markers without #mapMarker -->
  <map-marker *ngFor="let marker of markers" 
              [position]="marker.position" 
              [title]="marker.title"
              #mapMarker="mapMarker"
              (mapClick)="openInfo(mapMarker, marker.placeId)"
              [icon]="marker.icon"
              >
  </map-marker>

  <map-info-window id="info-window" *ngIf="!isSelectedCustomMarker && !isSelectedGlobal">
    <div *ngIf="selectedPlace">
      <h2 class="place-name">{{ selectedPlace.name }}</h2><br />
      <p>{{ selectedPlace.address }}</p>
      <strong>Travel Time by Car:</strong> {{ travelTimeCar }}<br />
      <strong>Travel Time by Walking:</strong> {{ travelTimeWalk }}
      <div *ngIf="selectedPlace.photoUrl">
        <img [src]="selectedPlace.photoUrl" alt="{{ selectedPlace.name }}" width="300px" />
      </div>
    </div>
  </map-info-window>
  
  <map-info-window id="info-window" *ngIf="isSelectedCustomMarker || isSelectedGlobal"> 
    <div *ngIf="selectedMarker">
      <h2 class="place-name">{{ selectedMarker.name }}</h2>
      <p>{{ selectedMarker.description }}</p>
      <strong>Travel Time by Car:</strong> {{ travelTimeCar }}<br />
      <strong>Travel Time by Walking:</strong> {{ travelTimeWalk }}
    </div>
    <div *ngIf="selectedMarker?.photoUrl">
      <img [src]="selectedMarker.photoUrl" alt="{{ selectedMarker.name }}" width="300px" />
    </div>
  </map-info-window>
</google-map>
